export default __webpack_public_path__ + "static/company-profile-eastman-84199640c73eb55fe73b12e30a0c8972.png";